import { isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
} from '@angular/core';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { UiServices } from 'src/app/services/ui-services';

@Component({
  selector: 'app-wpp-flotante',
  templateUrl: './wpp-flotante.component.html',
  styleUrls: ['./wpp-flotante.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WppFlotanteComponent implements OnInit, OnDestroy {
  @Input() logo = undefined;
  @Output() detectChangesEmitter = new EventEmitter();
  public showWpp = false;
  public dataWpp = undefined;
  public numWpp = undefined;
  public msgWpp = undefined;
  public emailData = {
    email: '',
    subject: '',
  };
  public actualRoute = undefined;
  private _headerSuscription = new Subscription();

  constructor(
    public paramSv: ParamServicesService,
    private _cdr: ChangeDetectorRef,
    private _uiSv: UiServices,
    private _iab: InAppBrowser,
    private translateSv: TranslateService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {}

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }

    this.paramSv.activeWpp && (this.showWpp = this.paramSv.activeWpp);
    this.actualRoute = window.location.pathname;
    this.setStyleWpp();
    this._headerSuscription = this.paramSv.emitImagesObs.subscribe(
      (item: any) => {
        if (item.name === 'wpp') {
          if (!this.numWpp) {
            this.setStyleWpp();
          }
        }
      }
    );
  }

  ngOnDestroy(): void {
    this._headerSuscription.unsubscribe();
  }

  setStyleWpp() {
    const data = this.paramSv.wpp;
    if (data) {
      this.numWpp = data.phone;
      this.msgWpp = data.msg;
      this.emailData.email = data.email;
      this.emailData.subject = data.subject;
      if (data.styleWpp) {
        const dataWpp = data.styleWpp;
        this.dataWpp = dataWpp;
      }
      this.paramSv.msgGalleryWpp = data.msgGallery;
      this.paramSv.msgWpp = this.msgWpp;
      this.paramSv.numWpp = this.numWpp;
    }
    this.detectChangesEmitter.emit();
    this._cdr.detectChanges();
  }

  async openWpp() {
    if (this.emailData.email) {
      let choosen = undefined;
      const translation = this.translateSv.instant(
        'ESCOGE_UNA_OPCION_DE_CONTACTO'
      );
      if (this.numWpp) {
        const { role } = await this._uiSv.presentAlert(
          translation,
          true,
          'Email',
          true,
          'WhatsApp',
          'ESCOGE_UNA_OPCION'
        );
        choosen = role;
      }

      if (choosen === 'accept' || !this.numWpp) {
        const url = `mailto:${this.emailData.email}?subject=${this.emailData.subject}`;
        this._iab.create(url, '_system');
        return true;
      } else if (choosen === 'backdrop') {
        return true;
      }
    }

    const url = `https://wa.me/${this.numWpp}?text=${this.msgWpp}`;
    this._iab.create(url, '_system');
  }
}
